import { environment } from 'src/environments/environment';

export abstract class BaseApiService {
  static readonly API_PREFIX = '/api/v1';

  protected readonly apiPrefix: string = BaseApiService.API_PREFIX;

  protected apiUrl(path: string): string {
    return environment.API_ENDPOINT + this.apiPrefix + path;
  }
}
